import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useOptionFactoryContract as n } from "../store/optionFactoryContract.mjs";
import "../store/subgraph.mjs";
import { commonOwner as r } from "../util/common.mjs";
const y = r(n);
async function O(t) {
  return await n(!0).createOption(
    ...Object.values(t)
  );
}
async function k() {
  return (await n().blankOptionCount()).toString();
}
async function d(t) {
  return await n(!0).cloneOption(t);
}
async function m(t, e, i, a) {
  return await n(!0).activateOption(
    t,
    e,
    i,
    a
  );
}
async function R(t, e) {
  return await n(!0).updateOptionStrike(t, e);
}
async function g(t) {
  return await n().operatorWhitelist(t);
}
async function B(t, e) {
  return await n(!0).setWhitelist(t, e);
}
async function P(t, e) {
  return await n(!0).extendStakingPoolEndBlock(
    t,
    e
  );
}
async function F(t) {
  return await n(!0).setStakingRewardPerBlock(t);
}
async function S() {
  return await n().stakingRewardPerBlock();
}
async function b(t, e) {
  return await n(!0).setOptionBulletToRewardRatio(
    t,
    e
  );
}
async function v(t, e) {
  return await n(!0).setOptionEntryFeeRatio(t, e);
}
async function C(t, e) {
  return await n(!0).setOptionExerciseFeeRatio(t, e);
}
async function h(t, e) {
  return await n(!0).setOptionWithdrawFeeRatio(t, e);
}
async function D(t, e) {
  return await n(!0).setOptionRedeemFeeRatio(t, e);
}
async function E() {
  return await n().blockTime();
}
async function T(...t) {
  return await n(!0).setBlockTime(...t);
}
async function W() {
  return await n().stakingPools();
}
async function x(...t) {
  return await n(!0).setStakingPools(...t);
}
async function G() {
  return await n().DOBStakingPool();
}
async function A(...t) {
  return await n(!0).setDOBStakingPool(...t);
}
async function j() {
  return await n().distributions();
}
async function q(...t) {
  return await n(!0).setDistributions(...t);
}
async function z() {
  return await n().ContractGenerator();
}
async function H(...t) {
  return await n(!0).setContractGenerator(...t);
}
async function I() {
  return await n().fund();
}
async function J(...t) {
  return await n(!0).setFund(...t);
}
async function K(...t) {
  return await n(!0).updateOptionFund(...t);
}
async function L(...t) {
  return await n(!0).removeActivatedOptions(...t);
}
export {
  z as ContractGenerator,
  G as DOBStakingPool,
  m as activateOption,
  k as blankOptionCount,
  E as blockTime,
  d as createBlankOptions,
  O as createOption,
  j as distributions,
  P as extendStakingPoolEndBlock,
  I as fund,
  g as operatorWhitelist,
  y as owner,
  L as removeActivatedOptions,
  T as setBlockTime,
  H as setContractGenerator,
  A as setDOBStakingPool,
  q as setDistributions,
  J as setFund,
  b as setOptionBulletToRewardRatio,
  v as setOptionEntryFeeRatio,
  C as setOptionExerciseFeeRatio,
  D as setOptionRedeemFeeRatio,
  h as setOptionWithdrawFeeRatio,
  x as setStakingPools,
  F as setStakingRewardPerBlock,
  B as setWhitelist,
  W as stakingPools,
  S as stakingRewardPerBlock,
  K as updateOptionFund,
  R as updateOptionStrike
};
//# sourceMappingURL=optionFactoryContract.mjs.map
